import React, { useState, useEffect, useContext } from 'react'
import MonthlySalesHeader from './MonthlySalesHeader'
import MonthlySalesInner from './MonthlySalesInner'
import MonthlySalesFooter from './MonthlySalesFooter'
import { appContext } from '../../../../../../App'
import { getMonthlySalesReport } from '../../../../ReportsFunctions'

export const monthlySalesContext = React.createContext()

function useMonthlySalesController() {
  const app = useContext(appContext)
  const [year, setYear] = useState(new Date(app.getClientDateTime()).getFullYear())
  const [monthlySalesReport, setMonthlySalesReport] = useState([])
  const [yearString, setYearString] = useState('')
  const months = [
    'January', 'February', 'March',
    'April', 'May', 'June',
    'July', 'August', 'September',
    'October', 'November', 'December'
  ]

  useEffect(() => {
    const init = async () => {
      setMonthlySalesReport(await getMonthlySalesReport(app, year))
      setYearString(year.toString())
    }

    if (year.toString().length === 4) init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year])

  return ({
    getClientDateTime: app.getClientDateTime,
    getClientTimezone: app.getClientTimezone,
    year: [year, setYear],
    monthlySalesReport: [monthlySalesReport, setMonthlySalesReport],
    yearString: [yearString, setYearString],
    months
  })
}

function MonthlySalesController(props) {
  const monthlySalesController = useMonthlySalesController()
  return (
    <React.Fragment>
      <monthlySalesContext.Provider value={monthlySalesController}>
        <MonthlySalesHeader />
        <MonthlySalesInner />
        <MonthlySalesFooter />
      </monthlySalesContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(MonthlySalesController)